import styled from 'styled-components';

interface StepButtonProps {
  selected?: boolean;
}

export const StyledUl = styled.ul`
  margin-bottom: 24px;
  margin-top: 0px;
  display: flex;
  padding-left: 12px;
`;

export const StyledLi = styled.li<StepButtonProps>`
  margin: 0 8px;
  cursor: pointer;

  &::marker {
    transition: all 0.3s linear;
    font-size: 20px;
    color: ${({ theme, selected }) => (selected ? theme.colors.black10 : theme.colors.black3)};
  }
`;
